export const pageName = {
  HOME: "Trang chủ",
  INTRODUCE: "Giới thiệu về Đất Vàng Việt Nam",
  CONTACTUS: "Trang liên hệ",
  GENARALPLANNING: "Trang tổng hợp quy hoạch Việt Nam",
  PROJECTINFO: "Trang thông tin bản đồ dự án",
  YEARBOOK: "Danh bạ KCN",
  BUYNSALE: "Trang mua bán",
  NEEDYOUKNOW: "Quy trình đầu tư dự án cần biết",
  LEGALDOCUMENTS: "Văn bản pháp lý",
  PLANNINGNEWS: "Tin tức tổng hợp về dự án",
  PROJECTNEWS: "Tin tức tổng hợp về dự án",
  MARKETNEWS: "Tin tức thông tin thị trường giá đất",
  NEWS: "Thông tin tổng hợp bất động sản hữu ích",
  
  //---
  REALSTATEPRICE: "Tra cứu thông tin bản đồ giá đất Việt Nam",
  PLANNING: "Trang tra cứu bản đồ quy hoạch ",
  FAQ: "Hỏi đáp - Hướng dẫn sử dụng",
  HELPING: "Trang hướng dẫn sử dụng",
};
